export function trans(intl, id) {
    return intl.formatMessage({id: id});
}